/// <amd-module name="Test/AnalyticsTestTrendWidget/AnalyticsTestTrendWidget" />
import { LoadingStatus, WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ChangeFlags, ViewComponentProps, WidgetFrameworkOperationId } from "Test/AnalyticsTestTrendWidget/TestTrendLegacyContracts";

import { ILegacyPlatformService } from "VSS/Legacy/Legacy";

// Legacy TFS Widget Contract

// AnalyticsTestTrend Widget Contracts
interface AnalyticsTestTrendWidgetState {
    analyticsTestTrendViewComponentType: any;
}

export interface IWidgetSettings {}

export class AnalyticsTestTrendWidget extends VssComponent<WidgetProps, AnalyticsTestTrendWidgetState> {
    public constructor(props: WidgetProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { analyticsTestTrendViewComponentType: undefined };
    }

    public async componentDidMount() {
        const legacyService: ILegacyPlatformService = this.context.pageContext.getService("ILegacyPlatformService");
        legacyService
            .requireModules(["TestManagement/Scripts/TestReporting/Analytics/Widgets/AnalyticsTestTrend/AnalyticsTestTrendViewComponentShim"])
            .then(analyticsTestTrendViewComponentType => {
                this.setState({ analyticsTestTrendViewComponentType: analyticsTestTrendViewComponentType });
            });
    }

    public render(): JSX.Element | null {
        const AnalyticsTestTrendComponent = this.state.analyticsTestTrendViewComponentType as any;
        return AnalyticsTestTrendComponent && AnalyticsTestTrendComponent[0]
            ? React.createElement(AnalyticsTestTrendComponent[0].default, this.generateAnalyticsTestTrendProps())
            : null;
    }

    /** Translate widget settings for the analyticsTestTrend widget to render via the "modern contract" */
    private generateAnalyticsTestTrendProps(): ViewComponentProps {
        const deferredRenderCompletion = {
            resolve: this.onRenderResolved,
            reject: this.onRenderFailed
        };
        return {
            deferredRenderCompletion: deferredRenderCompletion,
            change: {
                operationId: WidgetFrameworkOperationId.reload,
                detectedChanges: ChangeFlags.all,
                widgetCreationOptions: {
                    typeId: this.props.contributionId,
                    getId: this.getWidgetId,
                    showConfiguration: this.props.onConfigure
                },
                config: {
                    name: this.props.name,
                    isLightBox: false, // THis drives legacy lightbox rendering behavior, we don't use.
                    sizeInPixels: this.props.size,
                    customSettings: {
                        data: this.props.settings!,
                        version: this.props.settingsVersion
                    },
                    sizeInGrid: {} as any // AnalyticsTestTrend Sizes to content based on sizeInPixels
                }
            },
            suppressAnimations: !this.props.showLoadAnimations
        };
    }

    private onRenderResolved = (): void => {
        this.props.onWidgetLoaded();
    };

    private onRenderFailed = (error: string): void => {
        this.props.onWidgetLoaded({
            outcomeDescription: error,
            outcome: LoadingStatus.failure
        });
    };

    private getWidgetId = (): Promise<string> => {
        return Promise.resolve(this.props.id!);
    };
}

VssComponent.register("analyticsTestTrendWidget", AnalyticsTestTrendWidget);
